import { createContext, useContext, useEffect, useState } from 'react';

const NavSettingsContext = createContext();

export const NavSettingsProvider = ({ children }) => {
  const [selectedLabels, setSelectedLabels] = useState({});
  const [loading, setLoading] = useState(false)

  const toggleLabel = (name, labels) => {
    setSelectedLabels((prev) => {
      const updatedLabels = { ...prev, [name]: !prev[name] };
      const parent = labels.find(label => label.children.includes(name));
      if (parent) {
        const checkedChildren = parent.children.filter(child => updatedLabels[child]);
        if (checkedChildren.length === parent.children.length) {
          return prev; 
        }
      }
      return updatedLabels;
    });
  };
  return (
    <NavSettingsContext.Provider value={{ selectedLabels, toggleLabel, loading, setSelectedLabels, setLoading }}>
      {children}
    </NavSettingsContext.Provider>
  );
};
export const useNavSettings = () => useContext(NavSettingsContext);